import Field from "./Field";

export default function SituationStep({ state, update }) {
  return (
    <>
      <Field
        label="What happened?"
        placeholder="Give yourself the short version. No speeches."
        value={state.s1_whatHappened}
        onChange={(v) => update({ s1_whatHappened: v })}
        testId="field-s1-happened"
        rows={4}
      />
      <Field
        label="What was actually said or done?"
        placeholder="Actual words, actual actions. Not the ones you imagined."
        value={state.s1_saidOrDone}
        onChange={(v) => update({ s1_saidOrDone: v })}
        testId="field-s1-said"
        rows={4}
      />
      <Field
        label="What am I adding, assuming, or interpreting?"
        placeholder="Be honest. The story in your head isn't a fact yet."
        value={state.s1_addingAssuming}
        onChange={(v) => update({ s1_addingAssuming: v })}
        testId="field-s1-assuming"
        rows={4}
      />
    </>
  );
}
